export default "__VITE_ASSET__aa454195__"